import { ColDef, RowSelectionOptions } from 'ag-grid-community';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ActionCellRendererComponent } from '../../../helpers/action-cell-renderer-component/action-cell-renderer.component';
import { ServiceAreaService } from '../../../services/service-area.service';
import { OrganizationService } from '../../../services/organization.service';
import { Router, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ReadOnlyIfNoGroupPermissionDirectiveDirective } from '../../../directives/read-only-if-no-group-permission-directive.directive';

@Component({
  selector: 'app-service-area',
  standalone: true,
  imports: [AgGridAngular, RouterModule, ReadOnlyIfNoGroupPermissionDirectiveDirective],
  templateUrl: './service-area-list.component.html',
  styleUrl: './service-area-list.component.scss'
})
export class ServiceAreaListComponent implements OnInit, OnDestroy {

  private readonly _destroying$ = new Subject<void>();

  serviceAreas = [];
  columnDefs: ColDef[] = [
    { field: 'name', headerName: 'Name', sortable: true, filter: true },
    { field: 'templateGroupId', headerName: 'Template Group', sortable: true, filter: true },
    {
      field: 'id', headerName: 'Actions', cellRenderer: ActionCellRendererComponent, cellRendererParams:
      {
        context: {
          onDeleteAction: this.onDeleteServiceArea.bind(this),
          onEditAction: this.updateServiceArea.bind(this)
        }
      }
    }
  ];

  constructor(private serviceAreaService: ServiceAreaService,
    private organizationService: OrganizationService,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.loadServiceAreas();

    // Subscribe to service area changes
    this.serviceAreaService.serviceAreasChanged$
      .pipe(takeUntil(this._destroying$))
      .subscribe(() => {
        this.loadServiceAreas(); // Reload service areas when changed
    });

    this.organizationService.organizationId$
      .pipe(takeUntil(this._destroying$))
      .subscribe(() => {
        this.loadServiceAreas();
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  loadServiceAreas() {
    this.serviceAreaService.getServiceAreas().subscribe((data) => {
      if (data) {
        this.serviceAreas = data.sort((a: any, b: any) => a.name.localeCompare(b.name));
      } else {
        this.serviceAreas = [];
      }
    })
  }

  updateServiceArea(serviceArea: any) {
    this.router.navigate(['/service-areas/edit', serviceArea.id]);
  }

  onDeleteServiceArea(serviceArea: any) {
    this.serviceAreaService.deleteServiceArea(serviceArea.id).subscribe(() => {
      this.loadServiceAreas();
    });
  }
  
}